import * as React from 'react';
import { SVGProps } from 'react';

const IconSendMessageSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2.87 2.065a.6.6 0 0 0-.825.76l1.834 4.584 4.726.59-4.726.591-1.834 4.585a.6.6 0 0 0 .825.76l10.798-5.398a.6.6 0 0 0 0-1.074L2.87 2.065Z" />
  </svg>
);
export default IconSendMessageSizeS;
